<template>
  <div class="meau_wrap">
    <!--background-color="#fff"-->
    <el-menu
      class="menu whd-menu"
      @select="selectmenu"
      unique-opened
      text-color="#333"
      active-text-color="#29A7F4"
      :default-active="activeIndex"
    >
      <template v-for="(item, index) in menudata">
        <el-submenu
          v-if="item.children && item.children.length > 0"
          :index="item.url"
          :key="index"
        >
          <template slot="title">
            <i class="iconfont" :class="item.icon"></i>
            <span>{{ item.menuName }}</span>
          </template>
          <el-menu-item
            v-for="(subitem, sindex) in item.children"
            :index="subitem.url"
            :key="sindex"
            >{{ subitem.menuName }}
          </el-menu-item>
        </el-submenu>
        <el-menu-item v-else :index="item.url" :key="index">
          <i class="iconfont" :class="item.icon"></i>
          <span slot="title">{{ item.menuName }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>
<script>
import menulist from "./menu.js";
import api from "@/api.js";

export default {
  name: "menuview",
  data() {
    return {
      activeIndex: "/",
      menudata: [],
    };
  },
  created() {
    if (sessionStorage.getItem("navMenu")) {
      this.navMenu();
    } else {
      this.treeList();
    }
  },
  methods: {
    treeList() {
      sessionStorage.removeItem("newnavMenu");
      sessionStorage.removeItem("navMenu");
      this.axios
        .post(api.get_tree, {})
        .then((response) => {
          if (response.data.code === 0) {
            sessionStorage.setItem(
              "navMenu",
              JSON.stringify(response.data.tree)
            );
            this.navMenu();
          } else {
          }
        })
        .catch((response) => {});
    },
    navMenu() {
      let getItem = JSON.parse(sessionStorage.getItem("navMenu"));
      let newArray = {};
      let navMenu_list = menulist.meaulist;
      for (let i in getItem) {
        let newArray_ = {};
        for (let j in getItem[i].childs) {
          newArray_[getItem[i].childs[j].name] = getItem[i].childs[j];
        }
        getItem[i].childs = newArray_;
        newArray[getItem[i].name] = getItem[i];
      }
      sessionStorage.setItem("newnavMenu", JSON.stringify(newArray));
      for (let i in menulist.meaulist) {
        if (newArray[menulist.meaulist[i].menuName]) {
          let childs_list = [];
          for (let j in menulist.meaulist[i].children) {
            if (
              newArray[menulist.meaulist[i].menuName].childs[
                menulist.meaulist[i].children[j].menuName
              ]
            ) {
              childs_list.push(menulist.meaulist[i].children[j]);
            }
          }
          menulist.meaulist[i].children = childs_list;
          this.menudata.push(menulist.meaulist[i]);
        }
      }
    },
    selectmenu(index) {
      this.$router.push({ path: index });
    },
  },
  beforeUpdate() {
    this.activeIndex = this.$route.matched[1].path;
  },
};
</script>
